import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import PublishedTime from '../../_partials/PublishedTime';
import UserAvatar from '../../../User/Avatar/UserAvatar';
import UserLink from '../../../User/Link/UserLink';
import s from './UserInfoBlock.scss';
var UserInfoBlock = function (_a) {
    var user = _a.user, publishedTime = _a.publishedTime, shouldShowStageMsPromo = _a.shouldShowStageMsPromo;
    var t = useTranslation().t;
    var newMsPromo = useFlag('mobile_tier_promo_new');
    return (React.createElement("div", { className: s['root'] },
        React.createElement(UserAvatar, { size: 32, user: user, className: s['author-avatar'] }),
        React.createElement("span", { className: s['author-username'] },
            React.createElement(UserLink, { user: user, className: s['author-userlink'] }),
            (newMsPromo || !shouldShowStageMsPromo) && publishedTime && (React.createElement(PublishedTime, { publishedTime: publishedTime, withoutText: true })),
            shouldShowStageMsPromo && !newMsPromo && (React.createElement("span", { className: s['ms-promo-text'] }, t('submissionDetailsHeader.tierPromotion.body'))))));
};
UserInfoBlock.displayName = 'UserInfoBlock';
export default UserInfoBlock;
//# sourceMappingURL=UserInfoBlock.js.map